var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',_vm._b({staticClass:"navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl",attrs:{"id":"navbarBlur","data-scroll":"true"}},'nav',_vm.$attrs,false),[_c('div',{staticClass:"px-3 py-1 container-fluid"},[_c('breadcrumbs',{attrs:{"currentPage":_vm.currentRouteName,"textWhite":"text-white"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }